import React from 'react'
import PropTypes from 'prop-types'
import { Field, getIn } from 'formik'
import ErrorMessage from './ErrorMessage'
import { useSelector } from 'react-redux'
import { getStrength } from 'src/lib/Validation'

export default function TextFieldWrapper({
  formik,
  label,
  name,
  type,
  required,
  alertInfo,
  children,
  showBar,
  myData,
  handleCheck,
  labelClass,
  isAlphaNum,
}) {
  const generalData = useSelector((state) => state.generalData)
  const { touched, errors, values } = formik
  const psStrength = getStrength(values?.[name], myData, name?.toLowerCase() === 'username') || {}

  const handleBlur = async (e) => {
    if (name === 'username' || name === 'emailId' || name === 'oldUsername') {
      await handleCheck(e.target.value)
    }
    formik.handleBlur(e)
  }

  return (
    <div className={`form-group ${required}`}>
      <label className={labelClass}>{label}</label>
      {alertInfo !== '' && (
        <div className="alert-info" role="alert">
          {alertInfo}
        </div>
      )}
      <Field
        name={name}
        id={name}
        type={type}
        {...(type === 'password' && {
          onChange: (e) => {
            formik.setFieldValue(name, e.target.value.trim())
          },
        })}
        {...(isAlphaNum && {
          onChange: (e) => {
            const trimmedValue = e.target.value.replace(/[^a-zA-Z0-9]/g, '').trim()
            formik.setFieldValue(name, trimmedValue)
          },
        })}
        className={`form-control ${getIn(touched, name) && getIn(errors, name) ? 'is-invalid' : ''}`}
        onBlur={handleBlur}
      />
      {alertInfo === '' && !showBar ? (
        <ErrorMessage formik={formik} name={name} />
      ) : (
        <div> {children}</div>
      )}
      {showBar && values?.[name] !== '' && (
        <div className="password-prog-bar" style={{ display: 'block' }}>
          <div
            className={`progress-bar ${psStrength.className}`}
            style={{ width: psStrength.width }}
          >
            {psStrength.message}
          </div>
        </div>
      )}
      {showBar && errors?.[name] === generalData.txt_requiredmessage && (
        <ErrorMessage formik={formik} name={name} />
      )}
    </div>
  )
}

TextFieldWrapper.propTypes = {
  formik: PropTypes.object,
  type: PropTypes.string,
  label: PropTypes.string,
  labelClass: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.string,
  alertInfo: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  showBar: PropTypes.bool,
  myData: PropTypes.object,
  handleCheck: PropTypes.func.isRequired,
  isAlphaNum: PropTypes.bool,
}

TextFieldWrapper.defaultProps = {
  label: '',
  required: 'asterisk-input',
  type: 'text',
  alertInfo: '',
  showBar: false,
  labelClass: '',
  handleCheck: () => {},
  isAlphaNum: false,
}
